export function isBool(value: string) {
    return value.toLowerCase() === "true" || value.toLowerCase() === "false";
}
